import compact from 'lodash/compact';
import { t } from '../../utils/translate';

// utils

const chainValidators = (validators = []) => action => state =>
  validators.reduce((newState, validator) => validator(newState, action), {
    ...state,
    errorMessages: [],
    isValid: true,
  });

export const validate = action => state => {
  const validators = state.validators || action.validators;
  return chainValidators(validators)(action)(state);
};

export const reduceValidationResults = (
  state,
  { errorMessages, isValid, ...rest }
) => {
  return {
    ...state,
    ...rest,
    errorMessages: errorMessages
      ? state.errorMessages.concat([errorMessages])
      : state.errorMessages,
    isValid: state.isValid && isValid,
  };
};

export const mapPropsToValidators = (tests, validators) =>
  compact(
    Object.keys(tests).reduce(
      (list, name) => (tests[name] ? list.concat([validators[name]]) : list),
      []
    )
  );

//

export const getServerValidationErrors = props => state => {
  // This validator is only run once, on init
  const hasServerValError =
    !!props.serverValidationErrors &&
    !!props.serverValidationErrors.reason &&
    !!props.serverValidationErrors.reason.length;

  return {
    ...state,
    isValid: !hasServerValError,
    hasServerValError,
    errorMessages: hasServerValError
      ? [props.serverValidationErrors.reason]
      : [],
  };
};

// shared tests

export const isNotTouched = state => state && !state.isTouched;

export const isNotBlank = state =>
  state && state.value && !!state.value.trim().length;

// TODO: complete the validaion cycle by trimming persisted record
export const isCorrectLength = (validations, field, fieldType) => {
  if (fieldType === 'zipcode_us') {
    let fieldValue = field.value.trim()

    return fieldValue.length === validations.zipcode_length && /^\d*$/.test(fieldValue)
  } else {
    return true
  }
}

export const isWithinRange = (value, min, max) => {
  if (min && max) {
    let comparable  = parseFloat(value)

    return (comparable >= min && comparable <= max)
  } else {
    return true
  }
}

export const isWithinLimit = (value, min, max) => {
  let comparable  = parseFloat(value)

  if (min && !max) {
    return comparable >= min
  } else if (!min && max) {
    return comparable <= max
  }
}

export const isWithinPrecision = (validations, field, fieldType) => {
  const value = field.value

  if (fieldType !== 'numeric') {
    return true;
  } else if (!validations.precision) {
    return true
  } else {
    if (value.includes('.')) {
      return value.split('.')[1].length <= validations.precision
    } else {
      return true
    }
  }
}

export const numericValidations = (validations, field, fieldType) => {
  const value = field.value
  const range = validations.min && validations.max
  const limit = (validations.min && !validations.max) || (!validations.min && validations.max)

  if (fieldType !== 'numeric') {
    return true;
  } else if (!validations.min && !validations.max){
    return true;
  } else if (range) {
    return isWithinRange(value, validations.min, validations.max)
  } else if (limit) {
    return isWithinLimit(value, validations.min, validations.max)
  }
}

export const matrixOtherValidator = state => {
  const otherRow = state.rows.filter(row => row.other)[0];
  const hasOtherValue = !!state.otherValue.trim().length;
  const hasOtherRowSelection = otherRow.values
    ? !!otherRow.values.length
    : !!otherRow.value.trim().length;
  const isForgiven = !state.isOtherTouched || state.none;
  const isOtherValid =
    (hasOtherValue && hasOtherRowSelection) ||
    (!hasOtherValue && !hasOtherRowSelection) ||
    isForgiven;
  const errorMessages = isOtherValid ? null : [t('other_verbatim')];
  return reduceValidationResults(state, {
    errorMessages,
    isOtherValid,
    isValid: isOtherValid,
  });
};
